import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetUserById = {
  getUserById: { data: null, loading: false, error: null },
};

export const getUserById = createAsyncThunk('user/getUserById', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/users/${data}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetUserById = {
  [getUserById.pending]: (state) => {
    state.getUserById.loading = true;
    state.getUserById.error = null;
  },
  [getUserById.fulfilled]: (state, action) => {
    state.getUserById.loading = false;
    state.getUserById.data = action.payload;
    state.getUserById.error = null;
  },
  [getUserById.rejected]: (state, action) => {
    state.getUserById.loading = false;
    state.getUserById.error = action.payload;
  },
};
